import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import styles from '../../css/Form.module.css';
import { useTranslation } from 'react-i18next';

const Form = () => {
  const { t } = useTranslation("global");

  const form = useRef();
  const [disableFields, setDisableFields] = useState(false);
  const [checkinDate, setCheckinDate] = useState('');

  // ✅ EmailJS configuration
  const EMAILJS_SERVICE_ID = 'default_service';
  const EMAILJS_TEMPLATE_ID = 'template_utrnnpi';
  const EMAILJS_PUBLIC_KEY = 'zuOf13PdSZXjB6JXi';

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    return `${year}-${month}-${day}`;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    // 🧠 Honeypot check — if filled, it's likely a bot
    if (formData.get('company')) {
      console.log('Bot detected, aborting submission.');
      return;
    }

    emailjs
      .sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        form.current,
        {
          publicKey: EMAILJS_PUBLIC_KEY,
        }
      )
      .then(
        () => {
          console.log('SUCCESS!');
          alert(t("booking.submitSuccess"));
        },
        (error) => {
          console.error('FAILED...', error.text);
          alert(t("booking.submitFailure"));
        }
      );

    e.target.reset();
  };

  const handleShootingChange = (e) => {
    setDisableFields(e.target.checked);
  };

  const handleCheckinChange = (e) => {
    setCheckinDate(e.target.value);
  };

  return (
    <div className={styles.container}>
      <form ref={form} onSubmit={sendEmail}>
        <label>{t("booking.name")}</label>
        <input type="text" name="name" required />

        <label>{t("booking.surname")}</label>
        <input type="text" name="surname" required />

        <label>{t("booking.email")}</label>
        <input type="email" name="email" required />

        <label>{t("booking.tel")}</label>
        <input type="tel" name="telephone" required />

        <div className={styles.checkbox}>
          <label>{t("booking.shooting")}</label>
          <input type="checkbox" name="shooting" onChange={handleShootingChange} />
        </div>

        <label>{t("booking.checkin")}</label>
        <input
          type="date"
          name="checkin"
          disabled={disableFields}
          min={getCurrentDate()}
          onChange={handleCheckinChange}
          required
        />

        <label>{t("booking.checkout")}</label>
        <input
          type="date"
          name="checkout"
          disabled={disableFields}
          min={checkinDate}
          required
        />

        <label>{t("booking.guests")}</label>
        <input
          type="number"
          name="guests"
          disabled={disableFields}
          min="1"
          max="6"
          required
        />

        <label>{t("booking.breakfast")}</label>
        <select name="breakfast" disabled={disableFields}>
          <option value="italiana">{t("booking.italian")}</option>
          <option value="continentale">{t("booking.continental")}</option>
          <option value="vegetariana">{t("booking.vegetarian")}</option>
        </select>

        <div className={styles.checkbox}>
          <label>{t("booking.parking")}</label>
          <input type="checkbox" name="parking" disabled={disableFields} />
        </div>

        <label>{t("booking.message")}</label>
        <textarea name="message" />

        {/* 🕵️‍♂️ Honeypot field (hidden) */}
        <input
          type="text"
          name="company"
          style={{ display: 'none' }}
          tabIndex="-1"
          autoComplete="off"
        />

        <input type="submit" value={t("booking.submit")} />
      </form>
    </div>
  );
};

export default Form;
